import gql from 'graphql-tag';

export const getQuotePDF = gql`
  query getQuotePdf($quoteId: String!) {
    getQuotePdf(quoteId: $quoteId) {
      signedUrl
    }
  }
`;

export const getQuote = gql`
  query getQuote($quoteId: String!) {
    getQuote(quoteId: $quoteId) {
      quoteId
      erpQuoteRef
      milesQuoteRef
      quoteRevisionNumber
      status
      make {
        description
      }
      bodyType
      model {
        name
      }
      variant {
        name
        gears
        doors
        modelYear
        fuelTankCapacity
        transmission
        photos {
          path
        }
      }
      leaseTerm
      kmsPerYear
      novated {
        impactTakeHome
      }
      exteriorColour {
        name
      }
    }
  }
`;
